import React, { useState, useContext, useEffect, useRef } from 'react';
import { merge } from 'react-merge';
import { DropdownItem } from "../Shared/DropdownItem";
import { ReactComponent as Icon } from '../../assets/svg/drop_down.svg';
import { StyleContext } from '../../providers/StyleContextProvider';
import { InputValidation } from '../../models/InputValidation';
import { SelectorModel } from '../../models/SelectorModel';

interface Props {
    id?: string;
    name: string;  
    label: any;
    value: any;
    placeHolder: any; 
    items: SelectorModel[];
    styles?: any;
    disabled?: boolean;
    handleChange?(event?: React.ChangeEvent<HTMLInputElement>): void;
    onSelectItem?: (selector: string, selectedItem: SelectorModel) => void;
    validation?: InputValidation; 
}

export const Selector: React.FC<Props> = (props) => {
    const styleContext = useContext(StyleContext);
    const [styles, setStyles] = useState<any>(styleContext.getComponentStyle("selector"));
    const [hovered, setHovered] = useState<boolean>(false);
    const [hoveredIndex, setHoveredIndex] = useState<number>();
    const [selectedValue, setSelectedValue] = useState<string>();     
    const wrapperRef = useRef<HTMLDivElement>(null);
    const validation = props.validation; 
    const disable = props.disabled;   
    const isDropdownDisabled = !props.items?.length || props.items?.length === 1;

    useEffect(() => {
        let extendedStyles = merge(styles, props.styles);
        setStyles(extendedStyles);
    }, []);

    useEffect(() => {
        const defaultValue = props.value || "";
        setSelectedValue(defaultValue);
    }, [props.value]);
      
    const handleSelectItem = (item: SelectorModel) => {
        if (disable) return;
        setSelectedValue(item.value);
        setHovered(false);

        if(props.onSelectItem) {
            props.onSelectItem(props.name, item);
        }
    }

    const filteredItems = props.items.filter(
        item => item.value !== selectedValue 
    );

    return (
        <div 
            ref={wrapperRef} 
            style={ styles.mainWrapper}
            onMouseEnter={() => !isDropdownDisabled && setHovered(true)}  
            onMouseLeave={() => !isDropdownDisabled && setHovered(false)}
        >
            <label style={styles.label}>{props.label}</label>
            <div 
                style={{
                    ...styles.inputWrapper,
                    ...(hovered && styles.inputWrapper.hover), 
                    ...(validation?.valid && styles.valid),
                    ...(validation?.invalid && styles.invalid),
                    ...(disable && styles.disable)
                }}
                onClick={() => !isDropdownDisabled && setHovered(!hovered)}
            >
                <input
                    id={props.id}
                    style={styles.input}
                    name={props.name}
                    value={selectedValue}
                    disabled={disable}
                    placeholder={props.placeHolder}
                    onChange={props.handleChange}
                />
                {!isDropdownDisabled && <Icon style={{...styles.icon, ...(hovered && styles.icon.hover)}}/> }
            </div>
            <div style={ hovered ? styles.dropdownWrapper : {}}>
                <div style={styles.scrollArea} className="scrollArea">
                {hovered && filteredItems.map((item, index) =>
                    <div
                        key={item.id}
                        onMouseEnter={() => setHoveredIndex(item.id)}
                        onMouseLeave={() => setHoveredIndex(undefined)}
                    >
                        <DropdownItem 
                            styles={styles.dropdownItem}
                            onClick={() => handleSelectItem(item)} 
                        >
                            <div>{item.value}</div> 
                            {index < (filteredItems.length -1) && (
                                <hr 
                                    style={{...styles.bottomBorder, 
                                    ...(hoveredIndex === item.id ? styles.bottomBorder.hover : {})
                                }}/>
                            )}
                        </DropdownItem>
                    </div>
                )}
                </div> 
            </div>
        </div>
    );
}